import { type InferType, object, string } from "yup";
import { BankAddressInputFields } from "../constants";

export const SWIFT_CODE_NUMBER_MIN_LENGTH = 8;
export const SWIFT_CODE_NUMBER_MAX_LENGTH = 11;

export enum SwiftCodeInputFields {
  SwiftCode = "swiftCode",
  BankName = "bankName",
  BankAddress = "bankAddress",
}

export const swiftCodeBaseSchema = string()
  // Capitalize the input before validating since letters in Swift codes should always be capitalized
  .transform((value: string | undefined) => value?.toUpperCase())
  .matches(/^[A-Z0-9]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/, "Invalid SWIFT / BIC code format");

/**
 * This is only uses in tests.
 */
export const SwiftCodeInputSchema = object().shape({
  [SwiftCodeInputFields.SwiftCode]: swiftCodeBaseSchema.required("Required field"),
  [SwiftCodeInputFields.BankName]: string().matches(/\S/, "Bank name cannot be just spaces."),
  [SwiftCodeInputFields.BankAddress]: object().shape({
    [BankAddressInputFields.Country]: string(),
    [BankAddressInputFields.Line1]: string(),
    [BankAddressInputFields.Line2]: string(),
    [BankAddressInputFields.Locality]: string(),
    [BankAddressInputFields.PostalCode]: string(),
    [BankAddressInputFields.Region]: string(),
  }),
});

export type SwiftCodeInputSchemaType = InferType<typeof SwiftCodeInputSchema>;
